import * as React from 'react';
import styles from './Menu.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectHistoryMenuActive, 
  changeHistoryMenuAction,
} from '../../ducks';
import { MenuItem } from './';
import { MENU } from '../../lib/labels';
import { DateNavigator, SingleDayNavigator } from '../navigators';
import { SlideIn, SlideInHeader } from '../slidein';
import c from 'classnames';

export const HistoryMenu = () => {
  const history = useHistory();
  const historyMenuActive = useSelector(selectHistoryMenuActive);
  const dispatch = useDispatch();
  return (
    <SlideIn
      isActive={historyMenuActive}
      changeActiveState={() => dispatch(changeHistoryMenuAction())}
    >
      <div className={c(styles.menu, 'menu')}>
        <SlideInHeader
          titleText={MENU.DATE_NAVIGATOR.BUTTON_TEXT}
          clickHandler={changeHistoryMenuAction(!historyMenuActive)}
        />
        <div className={styles.inputfield}>
          <DateNavigator
            onSubmit={x => {
              history.push(`/datum/${x}`);
              dispatch(changeHistoryMenuAction(!historyMenuActive));
            }}
          />
        </div>
        <div className={styles.inputfield}>
          <SingleDayNavigator
            onSubmit={x => {
              history.push(`/nieuw/dag/${x}`);
              dispatch(changeHistoryMenuAction(!historyMenuActive));
            }}
          />
        </div>
        <MenuItem
          text={MENU.HISTORY_MENU.YESTERDAY}
          path='/nieuw/dag/1'
          onClick={() => {
            dispatch(changeHistoryMenuAction(!historyMenuActive));
          }}
        />
        <MenuItem
          text={MENU.HISTORY_MENU.PREVIOUS_WEEK}
          path='/nieuw/dag/7'
          onClick={() => {
            dispatch(changeHistoryMenuAction(!historyMenuActive));
          }}
        />
      </div>
    </SlideIn>
  );
};